import React, { useEffect, useMemo } from 'react';
import { ListOption, ModalTitle } from './styled';
import { Option } from '@app/src/common/Option';
import { SelectItemModel } from './SelectModel';

interface Props {
  data: SelectItemModel[];
  isDisplay?: boolean;
  activeIndex?: number;
  placeholder?: string;
  handleChange?: Function;
  modalTitle?: string;
  className?: string;
  showFirstItems?: number;
  optionColor?: string;
  handleKeyDown?: Function;
  handleRefItems?: Function;
}

export const SelectOptions: React.FC<Props> = ({
  data,
  isDisplay,
  activeIndex,
  handleChange,
  modalTitle,
  className,
  showFirstItems,
  optionColor,
  handleKeyDown,
  handleRefItems
}) => {

  const refSuggestionsList = useMemo(
    () => Array.from({ length: data.length }).map(() => React.createRef()),
    [data.length]
  );

  useEffect(() => {
    handleRefItems && handleRefItems(refSuggestionsList);
  }, [data]);

  const validData = (option: SelectItemModel) => {
    return option && option.data && option.data.description;
  };

  return(
    <ListOption
      isDisplay={isDisplay}
      className={className}
      showFirstItems={showFirstItems}
      onKeyDown={handleKeyDown}
    >
      <ModalTitle>{modalTitle}</ModalTitle>
      {
        data.map((option, index) => (
          <Option
            key={index}
            innerRef={refSuggestionsList[index]}
            active={index === activeIndex}
            text={option.text}
            pos={index}
            handleChange={handleChange}
            checked={index === activeIndex}
            subtext={validData(option)}
            colorActive={optionColor}
          />
        ))
      }
    </ListOption>
)};

SelectOptions.defaultProps = {
  showFirstItems: 1
}
